<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <!--//@*/*
    //    *RPD CSIG  App v0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <template>
      <div class="text-center">
        <!-- set remind -->
        <template>
          <div class="text-center">
            <v-dialog v-model="show_remind_diag" width="500">
              <v-card>
                <v-card-title
                  class="text-h5 grey lighten-2"
                  style="word-break: normal"
                >
                  Set Reminder
                </v-card-title>

                <v-card-text>
                  <template>
                    <v-form v-model="frm_remind_valid" ref="frm_assign">
                      <v-container>
                        <p>
                          Please enter a Date and a Note. An email will be sent
                          5 days before and on the date.
                        </p>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <v-text-field
                              placeholder="##/##/####"
                              v-model="remind_sug.date_rem"
                              v-mask="'##/##/####'"
                              label="Date"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="remind_sug.note"
                              required
                              solo
                              name="note"
                              label="Note"
                              auto-grow
                              counter="4000"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </template>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cmpbk" class="white--text" @click="add_reminder"
                    >Submit
                  </v-btn>
                  <v-btn text @click="show_remind_diag = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <!-- set assingn -->
        <template>
          <div class="text-center">
            <v-dialog v-model="show_assing_diag" width="500">
              <v-card>
                <v-card-title
                  class="text-h5 grey lighten-2"
                  style="word-break: normal"
                >
                  Email Assign
                </v-card-title>

                <v-card-text>
                  <template>
                    <v-form v-model="frm_ass_valid" ref="frm_assign">
                      <v-container>
                        <p>
                          Please enter the email of the person assigned to this
                          Public Comment.
                        </p>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="ass_sug.assigned"
                              :rules="emailRules"
                              label="E-mail"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </template>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="cmpbk"
                    class="white--text"
                    @click="set_assign_now"
                    >Submit
                  </v-btn>
                  <v-btn text @click="close_assing_diag">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <!-- recieved to draft or updated -->
        <v-dialog fullscreen persistent v-model="show_edit_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Edit Public Comment
            </v-card-title>

            <v-card-actions class="pa-2 sug-btn d-flex flex-lg-row">
              <!-- <v-spacer></v-spacer> -->
              <!-- <v-btn
                @click="sug_save_draft(csig)"
                class="black white--text mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn
                @click="sug_save_updated(csig)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon> Save</v-btn
              >
              <v-btn
                color="primary"
                text
                @click="close_edit"
                class="ml-0 mr-md-1"
              >
                Close
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text class="form-edit px-4">
              <v-container id="home-container" style="max-width: 768px">
                <h4 class="whitesmoke black--text">
                  Please complete the form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="csig.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          maxlength="120"
                          v-model="csig.name"
                          label="Name (optional):"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Comments (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="csig.comments"
                          name="Comments"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Internal Note (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="csig.note"
                          name="note"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn @click="sug_save_draft(csig)" class="black white--text">
                <v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn @click="sug_save_updated(csig)" class="black white--text">
                <v-icon left> $save </v-icon> Save</v-btn
              >
              <v-btn color="primary" text @click="close_edit"> Close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- draft to updated -->
        <v-dialog
          fullscreen
          persistent
          v-model="show_edit_draft_to_updated"
          width="500"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Edit Public Comment For Update
            </v-card-title>

            <v-card-actions class="pa-2 sug-btn d-flex flex-lg-row">
              <v-spacer></v-spacer>
              <v-btn
                @click="has_draft_x(csig_pub)"
                class="black white--text mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon>Save As Draft</v-btn
              >
              <v-btn
                @click="sug_save_updated(csig_pub)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon>Save</v-btn
              >
              <v-btn
                class="ml-0 mr-md-1"
                color="primary"
                text
                @click="close_edit_draft_to_updated"
              >
                Close
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text>
              <v-container
                class="whitesmoke black--text"
                id="home-container"
                style="max-width: 768px"
              >
                <h4 class="whitesmoke black--text">
                  Please complete the this form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="csig_pub.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="120"
                          v-model="csig_pub.name"
                          label="Name (optional):"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="50"
                          v-model="csig_pub.division"
                          :rules="requiredRule"
                          label="Division most impacted:"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Comment (8000 char.):</label>
                        <v-textarea
                          :rules="requiredRule"
                          maxlength="7999"
                          v-model="csig_pub.comments"
                          name="comments"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Suggested Solution (8000 char.):</label>
                        <v-textarea
                          :rules="requiredRule"
                          aria-required
                          required
                          maxlength="7999"
                          v-model="csig_pub.solution"
                          name="solution"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="policy">Is there a policy in place?</label>
                        <div style="visibility: hidden">row space</div>
                        <v-select
                          id="policy"
                          v-model="csig_pub.policy"
                          :items="policy_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="speak"
                          >Would you like to speak with someone regarding this
                          issue?</label
                        >
                        <v-select
                          id="speak"
                          v-model="csig_pub.speak"
                          :items="speak_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="csig_pub.speak == 'Yes'">
                      <v-col cols="12" md="12">
                        <v-text-field
                          maxlength="120"
                          v-model="csig_pub.speak_name"
                          label="Who would you like to speak with?:"
                          placeholder="Enter Full Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="cost"
                          >Is there a financial cost to the solution?</label
                        >
                        <v-select
                          id="cost"
                          v-model="csig_pub.cost"
                          :items="cost_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="funding"
                          >Has a funding stream been identified?</label
                        >
                        <v-select
                          id="funding"
                          v-model="csig_pub.funding"
                          :items="funding_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          >If funding stream yes, please discuss (8000
                          char.):</label
                        >
                        <v-textarea
                          maxlength="7999"
                          v-model="csig_pub.stream_discuss"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Other comments (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="csig_pub.comments"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="has_draft_x(csig_pub)" class="black white--text">
                <v-icon left> $save </v-icon> Save As Draft</v-btn
              >
              <v-btn
                @click="sug_save_updated(csig_pub)"
                class="black white--text"
              >
                <v-icon left> $save </v-icon> Save</v-btn
              >
              <v-btn color="primary" text @click="close_edit_draft_to_updated">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- updated to publish -->
        <v-dialog
          fullscreen
          persistent
          v-model="show_edit_dialog_updated"
          width="500"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Edit Comment
            </v-card-title>

            <v-card-actions class="pa-2 sug-btn d-flex flex-lg-row">
              <v-spacer></v-spacer>
              <!-- <v-btn
                @click="sug_save_draft_x(csig_pub)"
                class="black white--text"
                ><v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn
                @click="sug_save_updated(csig_pub)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-lg-2 mr-md-1"
                ><v-icon left> $save </v-icon>Save</v-btn
              >
              <!-- <v-btn
                @click="sug_save_published_prompt(csig_pub)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
                ><v-icon left> $save </v-icon>Save As Published</v-btn
              > -->
              <v-btn
                class="ml-0 mr-md-1"
                color="primary"
                text
                @click="close_edit_publish"
              >
                Close
              </v-btn>
            </v-card-actions>
            <v-list dense color="whitesmoke" style="width: 98%; margin: auto">
              <v-list-item-title class="ml-2">Reminders</v-list-item-title>
              <v-list-item-group>
                <v-list-item
                  v-for="item in lst_reminders_sug"
                  :key="item.reminderId"
                  style="border-bottom: 2px solid lightgray"
                >
                  <v-list-item-icon>
                    <v-icon x-large @click="del_reminder(item)">$delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-row dense>
                      <v-col cols="12" md="12">
                        <h3>
                          {{ item.date_rem_5days_prev }} : {{ item.date_rem }}
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <p>{{ item.note }}</p>
                      </v-col></v-row
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-divider class="mb-4"></v-divider>
            <v-card-text>
              <v-container
                class="whitesmoke black--text"
                id="home-container"
                style="max-width: 768px"
              >
                <h4 class="whitesmoke black--text">
                  Please complete the form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row dense style="margin-bottom: 0; padding-bottom: 0">
                      <v-col cols="12" md="12">
                        <label>Log of Updates and Actions</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="csig_pub.action_log"
                          name="update_log"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-btn
                      class="black white--text mb-2"
                      style="position: relative; top: -5px"
                      @click="add_to_log(csig_pub)"
                      >Add to Log</v-btn
                    >
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-textarea
                          maxlength="7999"
                          name="add_to_log"
                          v-model="new_log_text"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                        <!-- <v-text-field
                          solo
                          v-model="new_log_text"
                          placeholder="Enter new update/action here."
                        ></v-text-field> -->
                      </v-col>
                    </v-row>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="csig_pub.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="120"
                          v-model="csig_pub.name"
                          label="Name (optional):"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="50"
                          :value="'CS' + csig_pub.csigId"
                          label="REF NUM"
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Comments (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="csig_pub.comments"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                          readony
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Internal Note (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="csig_pub.note"
                          name="intertenalnote"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="d-flex flex-md-row flex-column">
              <v-spacer></v-spacer>
              <!-- <v-btn
                @click="sug_save_draft_x(csig_pub)"
                class="black white--text"
                ><v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn
                @click="sug_save_updated(csig_pub)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
                ><v-icon left> $save </v-icon>Save</v-btn
              >
              <!-- <v-btn
                @click="sug_save_published_prompt(csig_pub)"
                class="black white--text"
                ><v-icon left> $save </v-icon>Save As Published</v-btn
              > -->
              <v-btn color="primary" text @click="close_edit_publish">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!--  view read only -->
        <v-dialog fullscreen persistent v-model="show_view" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              View - Read Only
            </v-card-title>

            <v-card-actions>
              <v-btn class="black white--text" text @click="close_view">
                Close
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-text>
              <v-container
                class="whitesmoke black--text"
                id="home-container"
                style="max-width: 768px"
              >
                <h4 class="whitesmoke black--text">
                  Please complete the form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row dense style="margin-bottom: 0; padding-bottom: 0">
                      <v-col cols="12" md="12">
                        <label>Log of Updates and Actions</label>
                        <v-textarea
                          style="height: 150px"
                          maxlength="7999"
                          v-model="csig_pub.action_log"
                          name="update_log"
                          counter
                          outlined
                          dense
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-divider class="mb-4"></v-divider>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="csig_pub.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                          readonly
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          readonly
                          maxlength="120"
                          v-model="csig_pub.name"
                          label="Name (optional):"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          readonly
                          maxlength="50"
                          v-model="csig_pub.division"
                          :rules="requiredRule"
                          label="Division most impacted:"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          >Primary Request/Public Comment (8000 char.):</label
                        >
                        <v-textarea
                          readonly
                          :rules="requiredRule"
                          maxlength="7999"
                          v-model="csig_pub.request"
                          name="request"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Suggested Solution (8000 char.):</label>
                        <v-textarea
                          readonly
                          :rules="requiredRule"
                          aria-required
                          required
                          maxlength="7999"
                          v-model="csig_pub.solution"
                          name="solution"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="policy">Is there a policy in place?</label>
                        <div style="visibility: hidden">row space</div>
                        <v-select
                          readonly
                          id="policy"
                          v-model="csig_pub.policy"
                          :items="policy_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="speak"
                          >Would you like to speak with someone regarding this
                          issue?</label
                        >
                        <v-select
                          readonly
                          id="speak"
                          v-model="csig_pub.speak"
                          :items="speak_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="csig_pub.speak == 'Yes'">
                      <v-col cols="12" md="12">
                        <v-text-field
                          readonly
                          maxlength="120"
                          v-model="csig_pub.speak_name"
                          label="Who would you like to speak with?:"
                          placeholder="Enter Full Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="cost"
                          >Is there a financial cost to the solution?</label
                        >
                        <v-select
                          readonly
                          id="cost"
                          v-model="csig_pub.cost"
                          :items="cost_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="funding"
                          >Has a funding stream been identified?</label
                        >
                        <v-select
                          readonly
                          id="funding"
                          v-model="csig_pub.funding"
                          :items="funding_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          >If funding stream yes, please discuss (8000
                          char.):</label
                        >
                        <v-textarea
                          readonly
                          maxlength="7999"
                          v-model="csig_pub.stream_discuss"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Other comments (8000 char.):</label>
                        <v-textarea
                          readonly
                          maxlength="7999"
                          v-model="csig_pub.comments"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn class="black white--text" text @click="close_view">
                Close
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <auth></auth>

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="whitesmoke black--text"
        id="home-container"
        style="max-width: 768px"
      >
        <!-- <v-btn color="green" class="ma-3" @click="devadmin = !devadmin"
          >DEV Admin Toggle</v-btn
        > -->
        <h4 class="whitesmoke black--text" v-if="isadmin">
          Admin Area - {{ loggedin }}
        </h4>
        <v-card v-if="isadmin" color="white" class="white">
          <v-card-title>Public Comments</v-card-title>
          <!-- <v-card-actions>
            <v-btn
              class="white--text"
              color="cmpbk"
              large
              style="width: 100%"
              @click="new_pubcom"
              >Submit New Suggestion</v-btn
            >
          </v-card-actions> -->
          <!-- <v-btn v-if="debug" @click="SendEmails">send emails reminder</v-btn> -->
          <!-- filters -->
          <div class="filter-title ml-2">Filters:&nbsp; &nbsp;</div>
          <v-card-actions class="filter-btn-cntnr">
            <v-btn-toggle
              v-model="toggle_exclusive"
              mandatory
              class="filter-btn d-flex flex-lg-row flex-lg-nowrap flex-column flex-wrap"
            >
              <!-- color="indigo darken-4" class="white--text" -->
              <v-btn class=""> Received </v-btn>
              <v-btn class=""> Updated </v-btn>
              <!-- <v-btn class=""> Published </v-btn>
              <v-btn class=""> Your Drafts </v-btn> -->
            </v-btn-toggle>
          </v-card-actions>
          <!-- recieved -->
          <div v-if="toggle_exclusive == 0">
            <v-card
              class="sug-v-card mb-6 findit"
              elevation="2"
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="12" class="d-flex">
                    <v-text-field
                      clearable
                      label="Find:"
                      v-model="quickfind"
                      @input="qfind"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card
              v-for="sug in lst_recieved"
              :key="sug.csigId"
              color="whitesmoke"
              class="sug-v-card mb-6 findme"
              elevation="2"
              shaped
              style="width: 98%; margin: auto; margin-bottom: 20px"
              :id="'rcv' + sug.csigId"
            >
              <v-card-text>
                <v-container>
                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Submit Date: &nbsp;</label>
                      <article>{{ sug.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ sug.s_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Please Follow Up: &nbsp;</label>
                      <article>{{ sug.review }}</article>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Name: &nbsp;</label>
                      <article>{{ sug.name }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;CS{{ sug.csigId }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label
                        class="font-weight-bold"
                        :style="{ color: sug.text_color }"
                        >Status: &nbsp;</label
                      >
                      <article
                        class="font-weight-bold"
                        :style="{ color: sug.text_color }"
                      >
                        {{ sug.status }}
                      </article>
                    </v-col>
                  </v-row>
                  <v-expansion-panels v-if="sug.comments.length >= 100">
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        {{ sug.comments | first100 }}
                      </v-expansion-panel-header>
                      <!-- textarea -->
                      <v-expansion-panel-content eager class="textarea-fix">
                        <hr />
                        <textarea
                          readonly
                          style="width: 100%; height: auto"
                          v-model="sug.comments"
                        >
                        </textarea>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <textarea
                    style="
                      width: 100%;
                      background-color: white;
                      border: 1px solid darkgray;
                      padding: 5px;
                    "
                    readonly
                    class="sizeme"
                    v-model="sug.comments"
                    v-if="sug.comments.length < 100"
                  >
                  </textarea>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="
                    edit_allowed(sug, function () {
                      show_edit_now(sug);
                    })
                  "
                  >Edit</v-btn
                >
              </v-card-actions>
            </v-card>
          </div>

          <!--  drafts  -->
          <div v-if="toggle_exclusive == 3">
            <v-card
              v-for="sug in lst_drafts"
              :key="sug.csig_pubId"
              color="whitesmoke"
              class="mb-6"
              elevation="2"
              shaped
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-container>
                  <h3>Draft</h3>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Assigned: &nbsp;</label>
                      <article>{{ sug.assigned }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;CS{{ sug.csigId }}</article>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Submit Date: &nbsp;</label>
                      <article>{{ sug.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ sug.s_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Name: &nbsp;</label>
                      <article>{{ sug.name }}</article>
                    </v-col>
                  </v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        Comment
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <hr />
                        {{ sug.comments }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="
                    edit_allowed(sug, function () {
                      show_edit_now(sug);
                    })
                  "
                  >Edit</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="set_assign(sug)"
                  >Assign</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="delete_prompt(sug)"
                  >Delete</v-btn
                >
              </v-card-actions>
            </v-card>
            <p class="ml-4 pa-3" v-if="lst_drafts.length == 0">
              You do not have any draft Public Comments.
            </p>
          </div>
          <!--  updated  -->
          <div v-if="toggle_exclusive == 1">
            <v-card
              class="sug-v-card mb-6 findit"
              elevation="2"
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="12" class="d-flex">
                    <v-text-field
                      clearable
                      label="Find:"
                      v-model="quickfind_updated"
                      @input="qfind_updated"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              v-for="sug in lst_updated"
              :key="sug.csig_pubId"
              color="whitesmoke"
              class="mb-6 findme-updated"
              elevation="2"
              shaped
              style="width: 98%; margin: auto; margin-bottom: 20px"
              :id="'upd' + sug.csigId"
            >
              <v-card-text>
                <v-container>
                  <h3>Updated</h3>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Assigned: &nbsp;</label>
                      <article>
                        {{ sug.assigned }} {{ sug.assigned_date | ifnone_dt }}
                      </article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;CS{{ sug.csigId }}</article>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Submit Date: &nbsp;</label>
                      <article>{{ sug.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ sug.s_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Name: &nbsp;</label>
                      <article>{{ sug.name }}</article>
                    </v-col>
                  </v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        Comment
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <hr />
                        {{ sug.comments }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="show_edit_updated_now(sug)"
                  >Edit</v-btn
                >

                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="set_assign(sug)"
                  >Assign</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="delete_prompt(sug)"
                  >Delete</v-btn
                >
              </v-card-actions>
            </v-card>
            <p class="ml-4 pa-4" v-if="lst_updated.length == 0">
              There are no updated Public Comments right now.
            </p>
          </div>
          <!--published  -->
          <div v-if="toggle_exclusive == 2">
            <v-card
              class="sug-v-card mb-6 findit"
              elevation="2"
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="12" class="d-flex">
                    <v-text-field
                      clearable
                      label="Find:"
                      v-model="quickfind_published"
                      @input="qfind_published"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              v-for="sug in lst_published"
              :key="sug.csig_pubId"
              color="whitesmoke"
              findme-updated
              elevation="2"
              shaped
              class="findme-published"
              style="width: 98%; margin: auto; margin-bottom: 20px"
              :id="'pub' + sug.csigId"
            >
              <v-card-text>
                <v-container>
                  <h3>Published</h3>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Assigned: &nbsp;</label>
                      <article>
                        {{ sug.assigned }} {{ sug.assigned_date | ifnone_dt }}
                      </article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;CS{{ sug.csigId }}</article>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Submit Date: &nbsp;</label>
                      <article>{{ sug.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ sug.s_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Name: &nbsp;</label>
                      <article>{{ sug.name }}</article>
                    </v-col>
                  </v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        Comment
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <hr />
                        {{ sug.comments }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="show_edit_updated_now(sug)"
                  >Edit</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="set_assign(sug)"
                  >Assign</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="delete_prompt(sug)"
                  >Delete</v-btn
                >
                <v-btn color="cmpbk" class="white--text" @click="remind(sug)"
                  >Remind</v-btn
                >
              </v-card-actions>
            </v-card>
            <p class="ml-4 pa-4" v-if="lst_published.length == 0">
              There are no published Public Comments right now.
            </p>
          </div>
        </v-card>

        <!-- user read only section -->
        <v-card v-if="isadmin == false" class="mb-5">
          <!-- <v-card-actions>
            <v-btn
              class="white--text"
              color="cmpbk"
              large
              style="width: 100%"
              @click="new_pubcom"
              >Submit New Suggestion</v-btn
            >
          </v-card-actions> -->
          <v-text-field
            v-model="quickfind_view"
            class="white black--text"
            style="width: 96%; margin: 2%"
            label="Filter by"
            placeholder="Keyword"
            solo
            @input="qfind_view"
          ></v-text-field>
          <v-card-title>Published Public Comments and Outcomes</v-card-title>

          <v-card
            v-for="sug in lst_published"
            :key="sug.csig_pubId"
            :id="'viw' + sug.csigId"
            color="whitesmoke"
            class="mb-6 findme_view"
            elevation="2"
            shaped
            style="width: 98%; margin: auto; margin-bottom: 20px"
          >
            <v-card-text>
              <v-container>
                <h3>Published</h3>
                <v-row dense class="mt-2">
                  <v-col cols="12" md="6" class="d-flex">
                    <label>Assigned: &nbsp;</label>
                    <article class="d-flex">
                      {{ sug.assigned }} {{ sug.assigned_date | ifnone_dt }}
                    </article>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Ref Num: </label>
                    <article>&nbsp;CS{{ sug.csigId }}</article>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Submit Date: &nbsp;</label>
                    <article>{{ sug.submit_date }}</article>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Modified: &nbsp;</label>
                    <article>{{ sug.s_date }}</article>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Name: &nbsp;</label>
                    <article>{{ sug.name }}</article>
                  </v-col>
                </v-row>
                <v-row dense class="mb-3">
                  <v-col cols="12" class="d-flex">
                    <label>Preview: &nbsp;</label>
                    <article>{{ sug.request | previewText }}</article>
                  </v-col>
                </v-row>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Request and Updates
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <hr class="mb-3" />
                      <v-row dense style="margin-bottom: 0; padding-bottom: 0">
                        <v-col cols="12" md="12">
                          <label
                            style="
                              font-size: 14px;
                              color: black;
                              font-weight: 600;
                            "
                            >Log of Updates and Actions</label
                          >
                          <v-textarea
                            readonly
                            maxlength="8000"
                            name="update_log"
                            auto-grow
                            counter
                            outlined
                            dense
                            v-model="sug.action_log"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <label
                        style="color: black; font-size: 14px; font-weight: 600"
                        >Request</label
                      >
                      <v-row
                        class="mb-5"
                        dense
                        style="margin-bottom: 0; padding-bottom: 0"
                      >
                        <v-col cols="12" md="12">
                          <v-textarea
                            readonly
                            maxlength="8000"
                            name="update_log"
                            auto-grow
                            counter
                            outlined
                            dense
                            v-model="sug.request"
                          ></v-textarea
                        ></v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="cmpbk" class="white--text" @click="open_view(sug)"
                >View</v-btn
              >
            </v-card-actions>
          </v-card>
          <p class="ml-4 pa-4" v-if="lst_published.length == 0">
            There are no published Public Comments right now.
          </p>
        </v-card>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  article {
    color: blue;
  }
  .v-btn-toggle .v-item--active {
    background-color: white !important;
    color: blue !important;
  }

  #home-container {
    width: 94vw;
    max-width: 100vw;
    height: auto;
  }

  .filter-btn {
    width: 100%;
  }

  .filter-title {
    width: 98%;
  }

  .filter-btn-cntnr {
    width: 100%;
  }

  .sug-btn {
    flex-direction: column;
  }

  .sug-btn .v-btn {
    width: 56%;
  }

  .textarea-fix textarea {
    resize: none; /* Disable manual resizing */
    overflow: hidden; /* Prevent scrollbars */
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .sug-btn {
    flex-direction: row;
    justify-content: flex-end;
  }

  .sug-btn .v-btn {
    width: auto;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";
//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  components: { auth },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      debug: true,
      lst_reminders_sug: [],
      cur_sug: {},
      remind_sug: {
        date_rem: "",
        note: "",
      },
      remind_sug_new: {
        date_rem: "",
        note: "",
      },
      frm_remind_valid: true,
      show_remind_diag: false,
      quickfind_view: "",
      quickfind_updated: "",
      quickfind: "",
      quickfind_published: "",
      frm_ass_valid: false,
      show_view: false,
      new_log_text: "",
      ass_sug: {},
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      show_assing_diag: false,
      devadmin: true,
      show_edit_dialog_updated: false,
      show_edit_dialog_pub: false,
      show_edit_draft_to_updated: false,
      csig_pub: {},
      show_edit_dialog: false,
      lst_updated: [],
      lst_drafts: [],
      lst_recieved: [],
      lst_published: [],
      toggle_exclusive: undefined,
      user_props: {},
      policy_items: ["", "Yes", "No", "Do Not Know"],
      speak_items: ["", "Yes", "No"],
      cost_items: ["", "Yes", "No"],
      funding_items: ["", "Yes", "No"],

      new_csig: {
        csig_pubId: 0,
        csigId: 0,
        name: "",
        review: "",
        submit_date: "",

        comments: "",
        note: "",

        updated_date: "",
        assigned: "",
        assigned_date: "",
        action_log: "",
      },
      //       },

      csig: {
        csig_pubId: 0,
        csigId: 0,
        name: "",
        review: "",
        submit_date: "",

        comments: "",
        note: "",

        updated_date: "",
        assigned: "",
        assigned_date: "",
        action_log: "",
      },
      //  [csig_pubId]
      // ,[csigId]
      // ,[name]
      // ,[submit_date]
      // ,[comments]
      // ,[assigned]
      // ,[action_log]
      // ,[draft_date]
      // ,[updated_date]
      // ,[published_date]
      // ,[assigned_date]
      valid: false,
      firstname: "",
      lastname: "",
      requiredRule: [(v) => !!v || "Required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 10 characters",
      ],
      email: "",
    };
  },
  watch: {
    "$store.state.user": function () {
      if (this.$store.state.user.email != "") {
        let self = this;
        this.init();
      }
    },
  },
  computed: {
    // Define the computed property
    isadmin() {
      // return (
      //   this.$store.state.user.roles.indexOf("csig-admin") > -1 && this.devadmin
      // );
      return true;
    },
    loggedin() {
      return this.$store.state.user.email;
    },
  },
  filters: {
    previewText(value, maxLength = 60) {
      if (!value || typeof value !== "string") return "";
      if (value.length <= maxLength) return value;

      let spaceIndex = value.lastIndexOf(" ", maxLength);

      if (spaceIndex === -1) {
        spaceIndex = value.indexOf(" ", maxLength);
        if (spaceIndex === -1) spaceIndex = maxLength;
      }

      return value.slice(0, spaceIndex) + "…";
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    ifnone_dt(value) {
      if (value == "01/01/1900") {
        return "";
      } else {
        return value;
      }
    },
    first100(value) {
      if (value.length <= 100) {
        return value;
      } else {
        return value.slice(0, 100) + "...";
      }
    },
  },
  methods: {
    SendEmails() {
      //for publish edit

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "send_reminder_emails";
      formIn.activate = "stuff";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    del_reminder_now(rem) {
      //for publish edit

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "del_reminder_now";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.reminderId = rem.reminderId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.get_reminders4_sug(self.cur_sug);
          self.show_loader(false);
          this.swall_it("reminder Status", "Removed", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    del_reminder(item) {
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting the reminder for Date: '" +
          item.date_rem +
          "'. Continue?",
        "question?",
        function () {
          self.del_reminder_now(item);
        },
        null,
        null,
        function () {}
      );
    },
    get_reminders4_sug(sug) {
      //for publish edit

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "get_reminders4_sug";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.csig_pubId = sug.csig_pubId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_reminders_sug = self.mno(data);
          self.lst_reminders_sug.forEach((element) => {
            element.date_rem = self.format_date_us(element.date_rem);
            element.date_rem_5days_prev = self.format_date_us(
              element.date_rem_5days_prev
            );
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    add_reminder(sug) {
      console.log("add_reminder");
      let self = this;
      //validation
      if (this.isValidFutureDate(this.remind_sug.date_rem) == false) {
        self.swall_it(
          "Reminder Status",
          "Date must be valid and within one year of the future.",
          "warning",
          null,
          null
        );
        return true;
      }

      if (this.remind_sug.date_rem == "") {
        self.swall_it(
          "Reminder Status",
          "Date msut be valid and within one year of the future.",
          "warning",
          null,
          null
        );

        return true;
      }

      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.csig_pubId = this.cur_sug.csig_pubId;
      formIn.remind_sug = this.remind_sug;

      formIn.remind_sug.date_remx = this.format_date_sql(
        formIn.remind_sug.date_rem
      );

      formIn.apiname = "add_reminder";
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.remind_sug = self.mno(self.remind_sug_new);
          self.remind_sug.date_rem = "";
          self.show_remind_diag = false;
          self.swall_it("Reminder Status", "Added.", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    remind(sug) {
      //set a rminder for a date to take action.
      //a job will run to set the notifcations.
      //it should have a note.  5 days ahead.
      this.show_remind_diag = true;
      this.cur_sug = sug;
    },
    qfind_view() {
      if (this.quickfind_view != null && this.quickfind_view.length >= 3) {
        console.log("qfind_view " + this.quickfind_view);
        let lstcrds = document.querySelectorAll(".findme_view");
        lstcrds.forEach((element) => {
          element.style.display = "none";
        });

        //find things here
        lstcrds.forEach((element) => {
          let id = element.id;
          let idint = id.slice(3);

          const result = this.lst_published.find(
            (item) => parseInt(item.csigId) === parseInt(idint)
          );
          if (
            result.comments
              .toLowerCase()
              .indexOf(this.quickfind_view.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }

          if (
            element.innerHTML
              .toLowerCase()
              .indexOf(this.quickfind_view.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }
        });
      } else {
        let lstcrds = document.querySelectorAll(".findme_view");
        lstcrds.forEach((element) => {
          element.style.display = "block";
        });
      }
    },
    qfind_updated() {
      let self = this;
      if (
        this.quickfind_updated != null &&
        this.quickfind_updated.length >= 3
      ) {
        console.log("qfind_updated: " + this.qfind_updated);
        let lstcrds = document.querySelectorAll(".findme-updated");
        lstcrds.forEach((element) => {
          element.style.display = "none";
        });
        let self = this;
        //find things here
        lstcrds.forEach((element) => {
          let id = element.id;
          let idint = id.slice(3);
          // self.mrbreakpoint("qfind_updated");
          const result = this.lst_updated.find(
            (item) => parseInt(item.csigId) === parseInt(idint)
          );
          if (
            result.comments
              .toLowerCase()
              .indexOf(this.quickfind_updated.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }

          if (
            element.innerHTML
              .toLowerCase()
              .indexOf(this.quickfind_updated.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }
        });
      } else {
        let lstcrds = document.querySelectorAll(".findme-updated");
        lstcrds.forEach((element) => {
          element.style.display = "block";
        });
      }
    },
    qfind_published() {
      //      this.mrbreakpoint("qfind_published");
      let self = this;
      if (
        this.quickfind_published != null &&
        this.quickfind_published.length >= 3
      ) {
        console.log("quickfind_published: " + this.quickfind_published);
        let lstcrds = document.querySelectorAll(".findme-published");
        lstcrds.forEach((element) => {
          element.style.display = "none";
        });

        //find things here
        lstcrds.forEach((element) => {
          // self.mrbreakpoint("qfind_published2");
          let id = element.id;
          let idint = id.slice(3);

          const result = this.lst_published.find(
            (item) => parseInt(item.csigId) === parseInt(idint)
          );
          if (
            result.comments
              .toLowerCase()
              .indexOf(this.quickfind_published.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }

          if (
            element.innerHTML
              .toLowerCase()
              .indexOf(this.quickfind_published.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }
        });
      } else {
        let lstcrds = document.querySelectorAll(".findme-published");
        lstcrds.forEach((element) => {
          element.style.display = "block";
        });
      }
    },
    qfind() {
      if (this.quickfind != null && this.quickfind.length >= 3) {
        console.log(this.quickfind);
        let lstcrds = document.querySelectorAll(".findme");
        lstcrds.forEach((element) => {
          element.style.display = "none";
        });

        //find things here
        lstcrds.forEach((element) => {
          let id = element.id;
          let idint = id.slice(3);

          const result = this.lst_recieved.find(
            (item) => parseInt(item.csigId) === parseInt(idint)
          );
          if (
            result.comments
              .toLowerCase()
              .indexOf(this.quickfind.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }

          if (
            element.innerHTML
              .toLowerCase()
              .indexOf(this.quickfind.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }
        });
      } else {
        let lstcrds = document.querySelectorAll(".findme");
        lstcrds.forEach((element) => {
          element.style.display = "block";
        });
      }
    },

    expnd_textarea() {
      setTimeout(() => {
        let lst_all_textarea = document.querySelectorAll("textarea");
        console.log("expnd_textarea: " + lst_all_textarea.length);
        lst_all_textarea.forEach((textArea) => {
          textArea.style.height = "auto"; // Reset height to calculate full height
          textArea.style.height = `${textArea.scrollHeight}px`; // Set to the full height
        });
      }, 500);
    },
    size_recv_textarea() {
      let lst_all_textarea = document.querySelectorAll(".sizeme");
      lst_all_textarea.forEach((element) => {
        element.style.height = "auto"; // Reset height to calculate full height
        element.style.height = `${element.scrollHeight}px`; // Set to the full height
      });
    },
    deletenow(sug) {
      console.log("deletenow");

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "deletenow";
      formIn.csig_pubId = sug.csig_pubId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);

          self.swall_it("Delete Status", "Deleted.", "success", null, null);
          self.new_log_text = "";
          this.$nextTick(() => {
            self.refresh_all();
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_prompt(sug) {
      console.log("delete_prompt");
      let sugdel = this.mno(sug);
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "Do you wish to delete the Comment created on '" +
          sug.s_CreateDate +
          "'? Note: this will only delete the administrative copy and will not affect the originally received Comment.",
        "question",
        function () {
          self.deletenow(sugdel);
        },
        null,
        null,
        function () {}
      );
    },
    new_pubcom() {
      window.open("https://pubcom.renopd.com", "_self");
    },
    close_view() {
      this.show_view = false;
    },
    open_view(sug) {
      this.csig_pub = sug;
      this.show_view = true;
    },
    //new_log_text
    add_to_log(sug) {
      console.log("add_to_log");

      if (sug.action_log == null) {
        sug.action_log = "";
      }

      let new_log_text = this.new_log_text;

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "add_to_log";

      new_log_text =
        formIn.email.toUpperCase() +
        " - " +
        this.format_date_us(new Date()).toString() +
        " " +
        this.formatTimeAsMilitary(new Date()) +
        "--\n " +
        new_log_text +
        " \n\n" +
        sug.action_log;

      sug.action_log = new_log_text;

      formIn.csig_pubId = sug.csig_pubId;
      formIn.new_log_text = new_log_text;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);

          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          self.new_log_text = "";
          this.$nextTick(() => {
            self.refresh_all();
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    set_assign(sug) {
      this.ass_sug = this.mno(sug);
      this.show_assing_diag = true;
    },
    set_assign_now() {
      if (this.$refs.frm_assign.validate() == false) {
        this.swall_it(
          "Save Status",
          "Please check the email format.",
          "warning",
          null,
          null
        );
        return true;
      }

      console.log("set_assign_now");
      let sug = this.mno(this.ass_sug);
      this.ass_sug = {};

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "set_assign_now";
      formIn.csig_pubId = sug.csig_pubId;
      formIn.assigned = sug.assigned;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.close_assing_diag();
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          //self.$refs.form.reset();
          // self.csig = this.mno(self.new_csig);

          this.$nextTick(() => {
            self.refresh_all();
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    edit_allowed(sug, edit_function) {
      //this.mrbreakpoint("cb");
      console.log("edit_allowed");
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = sug.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == false) {
            edit_function(sug);
          } else {
            self.swall_it(
              "Save Status",
              "This public comment has already been reviewed and used by an administrator. Public comments can only be imported once. Please check the Updated section.",
              "warning",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    has_draft_updated(sug) {
      console.log("has_draft_updated : " + sug.csigId);
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = sug.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data == false) {
            self.sug_save_updated(sug);
          } else {
            this.swall_it(
              "Save Status",
              "This Public Comment is not available for saving as it is a draft or is already in another saved state.",
              "warning",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    has_draft_x(sug) {
      //this  has draft is used when the draft is coming from cisg_pub
      console.log("has_draft go");
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = sug.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data == false) {
            self.sug_save_draft(sug);
          } else {
            this.swall_it(
              "Save Draft Status",
              "This Public Comment already has a draft. Only one draft can exist for each Public Comment at a time.",
              "warning",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    has_draft(sug) {
      console.log("has_draft go");
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = sug.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data == false) {
            self.sug_save_draft(sug);
          } else {
            this.swall_it(
              "Save Draft Status",
              "This Public Comment already has a draft. Only one draft can exist for each Public Comment at a time.",
              "warning",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    sug_save_draft_x(sug) {
      // if (!this.$refs.form.validate()) {
      //   this.swall_it(
      //     "Save Status",
      //     "Please attend to the Fields marked in red.",
      //     "warning",
      //     null,
      //     null
      //   );
      //   return true;
      // }

      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "sug_save_draft";

      console.log("sub date: " + sug.submit_date);

      sug.submit_date = this.format_date_sql(sug.submit_date);
      sug.s_date = this.format_date_sql(sug.s_date);
      sug.s_CreateDate = this.format_date_sql(sug.s_CreateDate);

      if (sug.updated_date == "" || sug.updated_date == undefined) {
        sug.updated_date = "1900-01-01";
      }
      if (sug.assigned == "" || sug.assigned == undefined) {
        sug.assigned = "None";
      }

      formIn.csig = sug;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          self.show_edit_dialog_updated = false;
          self.show_edit_dialog = false;
          self.show_edit_dialog_pub = false;

          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    sug_save_draft(sug) {
      console.log("sub date: " + sug.submit_date);
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Save Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null
        );
        return true;
      }

      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "sug_save_draft";

      this.csig.submit_date = this.format_date_sql(this.csig.submit_date);
      this.csig.s_date = this.format_date_sql(this.csig.s_date);
      this.csig.s_CreateDate = this.format_date_sql(this.csig.s_CreateDate);

      if (this.csig.updated_date == "" || this.csig.updated_date == undefined) {
        this.csig.updated_date = "1900-01-01";
      }
      if (this.csig.assigned == "" || this.csig.assigned == undefined) {
        this.csig.assigned = "None";
      }

      formIn.csig = this.csig;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          //self.$refs.form.reset();
          // self.csig = this.mno(self.new_csig);
          self.show_edit_dialog_updated = false;
          self.show_edit_dialog = false;
          self.show_edit_dialog_pub = false;

          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    sug_save_updated(sug) {
      // if (!this.$refs.form.validate()) {
      //   this.swall_it(
      //     "Save Status",
      //     "Please attend to the Fields marked in red.",
      //     "warning",
      //     null,
      //     null
      //   );
      //   return true;
      // }

      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "sug_save_updated";

      sug.submit_date = this.format_date_sql(sug.submit_date);
      sug.s_date = this.format_date_sql(sug.s_date);
      sug.s_CreateDate = this.format_date_sql(sug.s_CreateDate);
      sug.updated_date = this.format_date_sql(sug.updated_date);

      if (sug.assigned == "" || sug.assigned == undefined) {
        sug.assigned = "None";
      }

      formIn.sug = sug;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          self.show_edit_dialog_updated = false;
          self.show_edit_draft_to_updated = false;
          //self.$refs.form.reset();
          // self.csig = this.mno(self.new_csig);
          self.close_edit_draft_to_updated();
          self.show_edit_draft_to_updated = false;
          self.show_edit_dialog = false;
          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg.msg, "error", null, null);
        });
    },
    sug_save_published_prompt(sug) {
      let self = this;
      this.swall_diag(
        "Public Comments",
        "Saving 'As Published' will make this Public Comment and the action log visible to the entire department. Do you wish to continue?",
        "question",
        function () {
          self.sug_save_published(sug);
        },
        null,
        null,
        function () {}
      );
    },
    sug_save_published(sug) {
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Save Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null
        );
        return true;
      }

      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "sug_save_published";

      sug.submit_date = this.format_date_sql(sug.submit_date);
      sug.s_date = this.format_date_sql(sug.s_date);
      sug.s_CreateDate = this.format_date_sql(sug.s_CreateDate);
      sug.updated_date = this.format_date_sql(sug.updated_date);

      if (sug.assigned == "" || sug.assigned == undefined) {
        sug.assigned = "None";
      }

      formIn.sug = sug;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          self.show_edit_dialog_updated = false;

          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    show_edit_updated_now(sug) {
      console.log("name: " + sug.name);
      this.cur_sug = sug;
      this.get_reminders4_sug(sug);
      this.csig_pub = this.mno(sug);
      this.show_edit_dialog_updated = true;
    },
    show_edit_draft_now(sug) {
      this.csig_pub = this.mno(sug);
      this.show_edit_draft_to_updated = true;
    },
    close_edit_draft_to_updated() {
      this.show_edit_draft_to_updated = false;
    },

    show_edit_now(sug) {
      this.csig = this.mno(sug);
      this.show_edit_dialog = true;
    },
    close_assing_diag() {
      this.show_assing_diag = false;
    },
    close_edit_pub() {
      this.show_edit_dialog_pub = false;
    },
    close_edit() {
      this.show_edit_dialog = false;
    },
    close_edit_publish() {
      this.show_edit_dialog_updated = false;
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Save Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null
        );
        return true;
      }
      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "save_csig";

      this.csig.submit_date = this.format_date_sql(this.csig.submit_date);
      formIn.csig = this.csig;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          self.$refs.form.reset();
          self.csig = this.mno(self.new_csig);

          this.$nextTick(() => {
            console.log("do the date");
            self.csig.submit_date = self.format_date_us(new Date());
          });

          //    self.csig.submit_date = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    get_user_props() {
      //not doing this now.

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "get_user_props";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.user_props = self.mno(data);
          self.new_csig.name =
            self.user_props.fname + " " + self.user_props.lname;

          self.csig = self.mno(self.new_csig);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    //lst_updated
    get_all_published() {
      let self = this;
      self.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_all_published";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_published = this.mno(data);
          for (let index = 0; index < self.lst_published.length; index++) {
            const sug = self.lst_published[index];
            sug.s_date = this.format_date_us(sug.s_date);
            sug.submit_date = this.format_date_us(sug.submit_date);
            sug.s_CreateDate = this.format_date_us(sug.s_CreateDate);
            sug.assigned_date = this.format_date_us(sug.assigned_date);

            //console.log("pub ass: " + sug.assigned_date);

            const tempElement = document.createElement("textarea");
            tempElement.innerHTML = sug.request;
            sug.request = tempElement.value;

            tempElement.innerHTML = sug.solution;
            sug.solution = tempElement.value;

            tempElement.innerHTML = sug.stream_discuss;
            sug.stream_discuss = tempElement.value;

            tempElement.innerHTML = sug.comments;
            sug.comments = tempElement.value;

            tempElement.remove();

            //submit_date
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_all_updated() {
      let self = this;
      self.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_all_updated";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_updated = this.mno(data);
          for (let index = 0; index < self.lst_updated.length; index++) {
            const sug = self.lst_updated[index];
            sug.s_date = this.format_date_us(sug.s_date);
            sug.submit_date = this.format_date_us(sug.submit_date);
            sug.s_CreateDate = this.format_date_us(sug.s_CreateDate);
            sug.assigned_date = this.format_date_us(sug.assigned_date);

            const tempElement = document.createElement("textarea");
            tempElement.innerHTML = sug.request;
            sug.request = tempElement.value;
            tempElement.remove();

            //submit_date
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_user_drafts() {
      let self = this;
      self.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_user_drafts";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_drafts = this.mno(data);
          for (let index = 0; index < self.lst_drafts.length; index++) {
            const sug = self.lst_drafts[index];
            sug.s_date = this.format_date_us(sug.s_date);
            sug.submit_date = this.format_date_us(sug.submit_date);
            sug.s_CreateDate = this.format_date_us(sug.s_CreateDate);
            sug.assigned_date = this.format_date_us(sug.assigned_date);

            const tempElement = document.createElement("textarea");
            tempElement.innerHTML = sug.request;
            sug.request = tempElement.value;
            tempElement.remove();

            //submit_date
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_all_recieved() {
      let self = this;
      self.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_all_recieved";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_recieved = this.mno(data);
          for (let index = 0; index < self.lst_recieved.length; index++) {
            const sug = self.lst_recieved[index];
            sug.s_date = this.format_date_us(sug.s_date);
            sug.submit_date = this.format_date_us(sug.submit_date);
            sug.s_CreateDate = this.format_date_us(sug.s_CreateDate);
            sug.assigned_date = this.format_date_us(sug.assigned_date);

            sug.text_color = self.set_text_color(sug.status);

            sug.comments = this.decodeHtml(sug.comments);

            // const tempElement = document.createElement("textarea");
            // tempElement.innerHTML = sug.request;
            // sug.request = tempElement.value;

            // tempElement.innerHTML = sug.solution;
            // sug.solution = tempElement.value;

            // tempElement.remove();

            //submit_date
          }
          setTimeout(() => {
            self.size_recv_textarea();
          }, 500);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    set_text_color(status) {
      if (status == "Updated") {
        return "red";
      }
      if (status == "Draft") {
        return "blue";
      }
      if (status == "Published") {
        return "green";
      }
      if (status == "Received") {
        return "purple";
      }
    },
    refresh_all() {
      this.get_all_recieved();
      this.get_user_drafts();
      this.get_all_updated();
      this.get_all_published();
    },
    decodeHtml(html) {
      this.mrbreakpoint("decode)");
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      const decoded = txt.value;
      txt.remove(); // ← we throw it away immediately
      return decoded;
    },
    init(self) {
      console.log("init");
      this.show_loader(false);
      this.csig = this.mno(this.new_csig);
      this.csig.submit_date = this.format_date_us(new Date());
      console.log("before init refresh all");
      this.refresh_all();
      //this.get_user_props();
      this.show_loader(false);
    },
  },
  mounted() {
    this.show_loader(true);
    var self = this;
    this.$nextTick(() => {
      //self.init();
    });
  },
};
</script>
